let started = false;

export async function startSentryIfNeeded(): Promise<void> {
  if (started) return;
  if (import.meta.env.MODE !== 'production') return;

  started = true;

  const Sentry = await import('@sentry/react');

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_APP,
    environment: import.meta.env.MODE ?? 'development',
    release: __APP_VERSION__,
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    // sendDefaultPii: true,
  });
}
